import { render, staticRenderFns } from "./ModalSelecionaEscala.vue?vue&type=template&id=26cc66a6"
import script from "./ModalSelecionaEscala.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaEscala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports